import { observer } from 'mobx-react'
import useSettingsManager from '../hooks/use-settings-manager'
import { InputDefaultBase } from '../inputs/InputDefaultBase'
import React from 'react'

export const LocalizedInput = observer(function Test ({
  type,
  name,
  size,
  value,
  stateObj,
  settingsKey = name,
  ...other
}) {
  let settings_manager = useSettingsManager()
  const _settings = settings_manager.getOtherSettings(settingsKey, value)
  const input_settings =
    typeof _settings === 'object' ? _settings : { title: _settings }

  const title =
    typeof input_settings.title === 'string' ? input_settings.title : null
  return (
    <InputDefaultBase
      title={title}
      onChange={e => {
        stateObj.setValue(name, e.target.value)
      }}
      name={name}
      size={size}
      type={type}
      value={stateObj[name]}
      {...other}
    />
  )
})
export const LocalizedInputRadioBox = observer(function Test ({
  name,
  size,
  value,
  stateObj,
  settingsKey = name,
  title,
  ...other
}) {
  let settings_manager = useSettingsManager()
  const _settings = settings_manager.getOtherSettings(settingsKey, value)
  const input_settings =
    typeof _settings === 'object' ? _settings : { title: _settings }

  const _title =
    typeof input_settings.title === 'string' ? input_settings.title : title
  return (
    <InputRadioBoxBase
      title={_title}
      onChange={e => {
        stateObj[name] = value
      }}
      name={name}
      size={size}
      checked={stateObj[name]===value}
      value={value}
      {...other}
    />
  )
})

function InputRadioBoxBase ({
  name,
  value,
  title: _title,
  description: _description,
  image: _image,
  checked,
  onChange:onchange,
  size
}) {
  const item_id = name + value
  const title = typeof _title === 'string' ? <div
    className={'input-box__title'}>{_title}</div> : null
  const description = typeof _description === 'string' ? <p>{_description}</p> : null

  const image_url = typeof _image === 'string' ? _image : null
  const image = image_url !== null ? <figure style={{ backgroundImage: `url(${image_url})` }}
                                             className={'input-box__image'}></figure> : null

  const classNames = image_url !== null ? 'input-radio-box input-box input-box--image' : 'input-radio-box input-box input-box--center'

  return (
    <aside className={classNames} data-size={size}>
      <input id={item_id} type={'radio'} name={name} value={value} checked={checked} onChange={onchange}/>
      <label htmlFor={item_id}>
        {image}
        <div>
          {title}
          {description}
        </div>
      </label>
    </aside>
  )
}
